import type { ProductAccordionsProps } from 'components/productdetail/accordions/ProductAccordions';
import { ItemInformationAccordion } from 'components/productdetail/accordions/ItemInformationAccordion';
import { SizeChartAccordion } from 'components/productdetail/accordions/SizeChartAccordion';
import { TechSpecsAccordion } from 'components/productdetail/accordions/TechSpecsAccordion';

export const ProductAccordionList = ({ colorId, product, productId, openSizeChartModal }: ProductAccordionsProps) => {
  const { detail: productDetail } = product;

  return (
    <div data-test-id="productAccordionListSections">
      <TechSpecsAccordion colorId={colorId} productDetail={productDetail} />
      <ItemInformationAccordion product={product} productId={productId} />
      <SizeChartAccordion productDetail={productDetail} openSizeChartModal={openSizeChartModal} colorId={colorId} />
    </div>
  );
};
